import React from 'react'
import { PrensaEngine } from '@xprog/prensa'

export const EmbedCode = PrensaEngine.styled('div', {
  width: '100%'
})

const ScriptCode: React.FC<any> = (props) => {
  return <EmbedCode dangerouslySetInnerHTML={{ __html: props.slotTemplateCode }} />
}

export default ScriptCode
